import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-69e18f52"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "notice-content"
};
var _hoisted_2 = {
  class: "notice-floor"
};
var _hoisted_3 = {
  class: "title"
};
var _hoisted_4 = {
  class: "content"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("section", {
    class: "notice-floor"
  }, [/*#__PURE__*/_createElementVNode("h4", null, "一、个人信息真实性承诺"), /*#__PURE__*/_createElementVNode("div", {
    class: "content"
  }, [/*#__PURE__*/_createElementVNode("p", null, " 本人系自愿报名参加本次活动，所提交的所有个人注册信息、学籍信息等均真实、准确、完整、有效。本人理解并授权组委会为组织、管理、评审、颁奖及宣传等与本活动直接相关的目的，在必要范围内使用本人上述信息。 ")]), /*#__PURE__*/_createElementVNode("h4", null, "二、个人独立性承诺"), /*#__PURE__*/_createElementVNode("div", {
    class: "content"
  }, [/*#__PURE__*/_createElementVNode("p", null, " 本人承诺将亲自、独立完成本次活动的所有环节（包括但不限于线上答题、编写代码、算法设计、作品创作等）。保证所提交的所有答案、代码、设计文档、创意作品等均为本人独立构思和完成的原创成果，不存在任何抄袭、剽窃、盗用他人成果的行为。 ")]), /*#__PURE__*/_createElementVNode("h4", null, "三、活动环境与工具合规性承诺"), /*#__PURE__*/_createElementVNode("div", {
    class: "content"
  }, [/*#__PURE__*/_createElementVNode("p", null, " 本人承诺在活动期间，将确保所使用的软硬件设备、网络环境及辅助工具完全符合组委会公布的相关要求： "), /*#__PURE__*/_createElementVNode("ol", {
    class: "info-order-list"
  }, [/*#__PURE__*/_createElementVNode("li", null, " 设备与环境：保证摄像头、麦克风、屏幕共享等监考工具全程正常开启并工作，确保活动环境安静、无干扰、无其他无关人员在场。 "), /*#__PURE__*/_createElementVNode("li", null, " 工具使用：除使用组委会专属活动平台提供的相关辅助工具外，绝不使用任何未经授权的第三方工具、软件、插件、人工智能生成工具、代码自动生成程序或远程协助服务。 "), /*#__PURE__*/_createElementVNode("li", null, " 网络与故障：本人已提前进行设备与网络测试。如因个人设备故障、网络中断、电源问题等个人原因导致活动中断、数据丢失或成绩无效，相应责任与后果由本人自行承担，与组委会无关。 ")])]), /*#__PURE__*/_createElementVNode("h4", null, "四、遵守活动规则承诺"), /*#__PURE__*/_createElementVNode("div", {
    class: "content"
  }, [/*#__PURE__*/_createElementVNode("p", null, " 本人已仔细阅读并完全理解《活动须知》、《诚信承诺书》等所有官方文件，并承诺严格遵守其中的所有规定。 ")]), /*#__PURE__*/_createElementVNode("h4", null, "五、保密义务承诺"), /*#__PURE__*/_createElementVNode("div", {
    class: "content"
  }, [/*#__PURE__*/_createElementVNode("p", null, " 本人承诺在组委会正式公布活动用题之前及活动进行期间，不以任何形式泄露、讨论、传播任何题目内容、解题思路或算法方案。对于本人的活动作品，同意组委会在活动结束后可根据需要进行保密期规定，并在此期间内持续履行保密义务 ")]), /*#__PURE__*/_createElementVNode("h4", null, "六、资格审查与违规责任承诺"), /*#__PURE__*/_createElementVNode("div", {
    class: "content"
  }, [/*#__PURE__*/_createElementVNode("p", null, " 本人同意并配合组委会进行必要的资格审查，并根据要求及时提供身份证件、学籍证明等相关材料；如经核查不符合活动条件，本人接受组委会取消活动资格的决定。 "), /*#__PURE__*/_createElementVNode("p", null, " 本人清楚知悉，如在活动过程中出现任何违反本承诺书或活动规则的行为（包括但不限于：身份信息造假、替考、作弊、使用违规工具、抄袭、扰乱活动秩序、泄露活动用题等），组委会有权根据情节严重程度，采取包括但不限于取消活动资格、成绩及所获奖项、通报批评、禁止参加后续活动等处理措施。本人对此类处理决定无条件接受，并愿意承担由此引发的一切法律责任和后果。 ")]), /*#__PURE__*/_createElementVNode("h4", null, "七、免责声明"), /*#__PURE__*/_createElementVNode("div", {
    class: "content"
  }, [/*#__PURE__*/_createElementVNode("p", null, " 本人理解并同意，本次活动为线上形式，组委会已尽合理努力保障活动的公平性。对于因不可抗力、网络波动、个人设备故障等非组委会原因导致的任何活动损失或影响，组委会不承担任何责任。 "), /*#__PURE__*/_createElementVNode("p", null, " 若本人未满18周岁，本人及法定监护人已共同阅读并认可本承诺书全部内容，活动期间的人身安全与健康保障由本人及监护人全权负责。 ")]), /*#__PURE__*/_createElementVNode("div", {
    class: "content"
  }, [/*#__PURE__*/_createElementVNode("p", null, "本人确认，本承诺书是本人真实意愿的表示，具有完全的法律效力。")])], -1);
});
var _hoisted_6 = {
  class: "footer"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "footer-tips"
  }, null, -1);
});
var _hoisted_8 = {
  class: "action-area"
};
var _hoisted_9 = /*#__PURE__*/_createTextVNode("暂不答题");
var _hoisted_10 = /*#__PURE__*/_createTextVNode(" 我已阅读，并同意以上内容 ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_spin = _resolveComponent("a-spin");
  var _component_a_button = _resolveComponent("a-button");
  var _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    width: "860px",
    visible: _ctx.data.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.data.visible = $event;
    }),
    title: _ctx.data.commitmentLetterTitle || '活动须知',
    "mask-closable": false,
    centered: ""
  }, {
    footer: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_createVNode(_component_a_button, {
        onClick: _ctx.onClose
      }, {
        default: _withCtx(function () {
          return [_hoisted_9];
        }),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_a_button, {
        type: "primary",
        onClick: _ctx.onStartExamButtonClick
      }, {
        default: _withCtx(function () {
          return [_hoisted_10];
        }),
        _: 1
      }, 8, ["onClick"])])])];
    }),
    default: _withCtx(function () {
      return [_createVNode(_component_a_spin, {
        size: "large",
        tip: "正在加载数据中...",
        spinning: _ctx.loading,
        delay: 200
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, "本人" + _toDisplayString(_ctx.data.userName), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("p", null, " 已充分阅读、理解并同意“" + _toDisplayString(_ctx.ruleContestTip) + "”的全部规则与要求。现就相关事宜郑重承诺如下： ", 1)])]), _hoisted_5])];
        }),
        _: 1
      }, 8, ["spinning"])];
    }),
    _: 1
  }, 8, ["visible", "title"]);
}